import { useContextStrict } from 'hooks/useContextStrict';
import { IntlContext } from 'contexts/IntlContext';

export const useIntlCode = () => {
  const { langCode } = useContextStrict(IntlContext);

  return langCode;
};
